import styled from 'styled-components'

export const Separador = styled.div`
  width: 100%;
  margin: 12px 4px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey24};
`
